import { render, staticRenderFns } from "./ProjectFlowDetail.vue?vue&type=template&id=5747c59e&"
import script from "./ProjectFlowDetail.vue?vue&type=script&lang=js&"
export * from "./ProjectFlowDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProjectFlowDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports